import { TopologySubscription } from '../../../../../services/eventingApi';
import { Section } from '../shared/ui';
import BackfillForm from './BackfillForm';

const BackfillTab = ({ subscriptions }: { subscriptions: TopologySubscription[] }) => (
  <Section title="Backfill por RepublishSnapshot" subtitle="O serviço dono monta o snapshot atual de cada agregado e publica só para o consumidor escolhido">
    <BackfillForm subscriptions={subscriptions} />
  </Section>
);

export default BackfillTab;
